import { InjectionToken } from "@angular/core";
import { PriorityLevelsPort } from "./priority-levels.port";

export const PRIORITY_LEVELS_PORT = new InjectionToken<PriorityLevelsPort>("PRIORITY_LEVELS_PORT");
